module.exports = __webpack_public_path__ + "static/media/office.941911dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/office.svg
// module id = 288
// module chunks = 0